import * as React from 'react';

import { t } from 'state/intl/translations';

import { Header, HeaderContainer, SubText } from './history-header.styled';

const HistoryHeader = () => {
  return (
    <HeaderContainer>
      <Header>{t('yourCrownOrders')}</Header>
      <SubText>{t('viewPurchasesAndOffers')}</SubText>
    </HeaderContainer>
  );
};

export default HistoryHeader;
